export interface HouseRule {
  title: string;
  detail: string;
  icon: 'smoking' | 'pets' | 'party' | 'shield' | 'clock' | 'users';
}
export const houseRules: HouseRule[] = [{
  title: 'Check-in 2 PM · Checkout 12 noon',
  detail: 'Early check-in and late checkout can be requested while booking. Each carries a ₦70,000–₦100,000 fee, charged only if approved.',
  icon: 'clock'
}, {
  title: 'Refundable caution fee',
  detail: 'A mandatory ₦100,000 deposit is collected upfront on every apartment booking to safeguard against property damage, and refunded after an uneventful checkout.',
  icon: 'shield'
}, {
  title: 'No smoking',
  detail: 'Smoking is not permitted. Smoking forfeits the caution fee.',
  icon: 'smoking'
}, {
  title: 'No pets',
  detail: 'We cannot accommodate animals of any size, including service animals, at this time.',
  icon: 'pets'
}, {
  title: 'No parties or events',
  detail: 'Gatherings are limited to registered guests. Shoots and productions are welcome when booked in advance.',
  icon: 'party'
}, {
  title: 'Capacity is strictly capped',
  detail: 'Three-bedroom apartments host a maximum of 10 guests; two-bedroom apartments a maximum of 7.',
  icon: 'users'
}];
export const contactDetails = {
  phone: '+234 803 555 0142',
  phoneHref: 'tel:+2348035550142',
  whatsapp: '+234 803 555 0142',
  whatsappHref: 'https://wa.me/2348035550142',
  email: 'hello@belairluxuryapartments.com',
  emailHref: 'mailto:stay@belairbenin.com',
  address: '11 Ededaro Street, Off Oni Street, Off Ihama Road, GRA, Benin City, Edo State, Nigeria',
  hours: 'Bookings answered daily'
};
export const propertyStats = [{
  value: '3-Bed',
  label: 'Apartments for up to 10 guests'
}, {
  value: '2-Bed',
  label: 'Apartments for up to 7 guests'
}, {
  value: '24/7',
  label: 'Generator-backed power'
}, {
  value: '24h',
  label: 'Internet, always on'
}];